import { Col, Row } from "antd";
import React, { useEffect } from "react";
import CustomTabs, { tabsProps } from "../../../components/Tabs";
import Summary from "./About/Summary";
import Timeline from "./About/Timeline";
import WallActivity from "./About/WallActivity";
import { useNavigate } from "react-router-dom";

const About = () => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate('summary')
    }, [])

    const tabs: tabsProps[] = [{
        label: 'Summary',
        key: 'summary',
        content: <Summary />
    },
        // {
        //     label: 'Timeline',
        //     key: 'timeline',
        //     content: <Timeline />
        // },
        // {
        //     label: 'Wall Activity',
        //     key: 'wall-activity',
        //     content: <WallActivity />
        // }
    ]


    return (
        <Row gutter={[20, 20]}>
            <Col span={24}>
                <CustomTabs
                    tabs={tabs}
                    defaultActiveKey={tabs[0].key}
                    onTabChange={(key) => console.log(key)}
                    routes={true}
                />
            </Col>
        </Row>
    );

}

export default About;